module.exports = __webpack_public_path__ + "static/media/theme-72.5a1e1b85.jpg";